import { useEffect, useState } from "react";
import { fetchReadingHistory } from "./api";

export default function useReadingHistory() {
  const [feature, setFeature] = useState(null);
  const [page, setPage] = useState(1);
  const [state, setState] = useState({
    loading: true,
    loadingMore: false,
    error: "",
    data: null,
  });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const isLoadMore = page > 1;
      setState((prev) => ({
        ...prev,
        loading: !isLoadMore,
        loadingMore: isLoadMore,
        error: "",
      }));
      try {
        const data = await fetchReadingHistory({ page, feature });
        if (cancelled) return;
        setState((prev) => {
          if (!isLoadMore || !prev.data) {
            return { loading: false, loadingMore: false, error: "", data };
          }
          return {
            loading: false,
            loadingMore: false,
            error: "",
            data: {
              ...data,
              items: [...(prev.data.items || []), ...(data.items || [])],
              pagination: data.pagination,
            },
          };
        });
      } catch (error) {
        if (cancelled) return;
        setState((prev) => ({
          loading: false,
          loadingMore: false,
          error: error?.message || "reading_history_load_failed",
          data: isLoadMore ? prev.data : null,
        }));
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [feature, page]);

  const setFeatureFilter = (nextFeature) => {
    setFeature(nextFeature);
    setPage(1);
  };

  const loadMore = () => {
    if (state.loading || state.loadingMore) return;
    if (!state.data?.pagination?.has_more) return;
    setPage((prev) => prev + 1);
  };

  return {
    ...state,
    feature,
    setFeatureFilter,
    loadMore,
  };
}
